class ProductGallery extends HTMLElement {
  connectedCallback() {
    const dataEl = this.querySelector('[data-gallery-media]');
    if (!dataEl) return;

    try {
      this.media = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(this.media) || this.media.length === 0) return;

    this.currentIndex = 0;
    this.mainImage = this.querySelector('[data-gallery-main-image]');
    this.zoomImage = this.querySelector('[data-gallery-zoom-image]');
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.select(index));
    });

    this.addEventListener('command', (event) => {
      if (event.command === '--prev') {
        event.preventDefault();
        this.step(-1);
      } else if (event.command === '--next') {
        event.preventDefault();
        this.step(1);
      }
    });

    const dialog = this.querySelector('dialog');
    if (dialog) {
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });
    }

    this.setupMoreCue();
  }

  // "More photos" fade/chevron cue (owner brief, 2026-10-30): shown only while the
  // thumbnail rail actually has more content past the visible edge in that scroll
  // direction — not a static decoration that outlives the real scroll position.
  setupMoreCue() {
    const rail = this.querySelector('[data-gallery-thumb-rail]');
    const fadeX = this.querySelector('[data-gallery-more="x"]');
    const fadeY = this.querySelector('[data-gallery-more="y"]');
    if (!rail || (!fadeX && !fadeY)) return;

    const update = () => {
      if (fadeX) {
        const hasMoreX = rail.scrollWidth - rail.scrollLeft - rail.clientWidth > 1;
        fadeX.hidden = !hasMoreX;
      }
      if (fadeY) {
        const hasMoreY = rail.scrollHeight - rail.scrollTop - rail.clientHeight > 1;
        fadeY.hidden = !hasMoreY;
      }
    };

    update();
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  step(direction) {
    const count = this.media.length;
    this.select((this.currentIndex + direction + count) % count);
  }

  select(index) {
    const item = this.media[index];
    if (!item) return;
    this.currentIndex = index;

    if (this.mainImage) {
      this.mainImage.src = item.src;
      this.mainImage.srcset = item.srcset;
      this.mainImage.alt = item.alt;
    }
    if (this.zoomImage) {
      this.zoomImage.src = item.src;
      this.zoomImage.srcset = item.srcset;
      this.zoomImage.alt = item.alt;
      this.zoomImage.width = item.width;
      this.zoomImage.height = item.height;
    }

    this.thumbs.forEach((thumb, thumbIndex) => {
      thumb.setAttribute('aria-selected', thumbIndex === index ? 'true' : 'false');
    });
  }
}

customElements.define('product-gallery', ProductGallery);
